import { i18nFilter } from "app/filters/i18nFilter";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import ClaimedCard from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/ClaimedCard/ClaimedCard";
import DisabledCard from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/DisabledCard/DisabledCard";
import UnclaimedCard from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/UnclaimedCard/UnclaimedCard";
import type {
    CardConfig,
    CardStatus,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/utils/consts";

export const getCardConfig = (
    cardItem: IPackage,
    status: CardStatus,
    remainingReferrals: number,
    index: number,
): CardConfig => {
    const i18n = i18nFilter();
    const toUnlockText = i18n("rewards_modal.main_screen.rewards_section.to_unlock", { referrals: remainingReferrals });

    switch (status) {
        case "claimed":
            return {
                cardComponent: <ClaimedCard cardItem={cardItem} />,
                unlockText: i18n("rewards_modal.main_screen.rewards_section.reward_claimed"),
            };
        case "disabled":
            return {
                cardComponent: <DisabledCard cardItem={cardItem} />,
                unlockText: "",
            };
        case "open":
        default:
            const saveUpToText = i18n(
                `rewards_modal.main_screen.rewards_section.unclaimed_card.save_up_to.index${index + 1}`,
            );
            return {
                cardComponent: (
                    <UnclaimedCard
                        cardItem={cardItem}
                        saveUpToText={saveUpToText}
                    />
                ),
                unlockText: toUnlockText,
            };
    }
};
